module.exports = __webpack_public_path__ + "img/mm.8d6d26bc.svg";